import script from "./subCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./subCompany.vue?vue&type=script&setup=true&lang=js"

import "./subCompany.vue?vue&type=style&index=0&id=3829e3de&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3829e3de"]])

export default __exports__